export const exportToCSV = (data: any[], filename: string, columns?: { key: string; label: string }[]) => {
    if (!data || data.length === 0) {
        console.warn('No data to export');
        return;
    }

    // If columns are not specified, use all keys from the first object
    const csvColumns = columns || Object.keys(data[0]).map(key => ({ key, label: key }));
    
    // Create CSV header
    const header = csvColumns.map(col => `"${col.label}"`).join(',');
    
    // Create CSV rows
    const rows = data.map(row => {
        return csvColumns.map(col => {
            let value = row[col.key];
            
            // Handle different data types
            if (value === null || value === undefined) {
                value = '';
            } else if (value instanceof Date) {
                value = value.toLocaleDateString();
            } else if (typeof value === 'object') {
                value = JSON.stringify(value);
            } else {
                value = String(value);
            }
            
            // Escape quotes and wrap in quotes if contains comma, quote, or newline
            if (value.includes('"')) {
                value = value.replace(/"/g, '""');
            }
            if (value.includes(',') || value.includes('"') || value.includes('\n')) {
                value = `"${value}"`;
            }
            
            return value;
        }).join(',');
    });
    
    // Combine header and rows
    const csvContent = [header, ...rows].join('\n');
    
    // Create and download file
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    
    if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', `${filename}.csv`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
};
